import { render, staticRenderFns } from "./setting-smartReview.vue?vue&type=template&id=6a0a5b18&scoped=true&"
import script from "./setting-smartReview.vue?vue&type=script&lang=js&"
export * from "./setting-smartReview.vue?vue&type=script&lang=js&"
import style0 from "./setting-smartReview.vue?vue&type=style&index=0&id=6a0a5b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a5b18",
  null
  
)

export default component.exports